<template>
  <ul class="sidebar-nav lms-nav">
    <li class="nav-item show">
      <a
        @click="navhome()"
        class="nav-link"
        :class="{ active: 0 == $route.params.bid }"
        role="button"
      >
        <feather type="info"></feather>Тухай
      </a>
    </li>
    <li class="nav-item show" v-for="(b, i) in boxes" :key="i">
      <a
        @click="navopen(b)"
        class="nav-link"
        :class="{ active: b.id == $route.params.bid }"
        role="button"
      >
        <feather :type="b.icon"></feather>{{ b.nm }}
        <!-- {{b.ot}}
        ({{b.tasks.length}},{{b.forms.length}},{{b.attaches.length}}) -->
      </a>
      <nav class="nav" v-if="b.tasks.length">
        <!-- <a @click="navopen(b)" role="button" :class="{'active': b.id==$route.params.bid && $route.params.iid==0 }">
            <span class="text-uppercase tx-12">Бүх {{b.nm}}</span>
        </a> -->
        <a
          @click="subNavOpen(b, t)"
          role="button"
          v-for="(t, i) in b.tasks"
          :key="i"
          :class="{ active: t.id == $route.params.iid }"
        >
          <div class="d-flex align-items-center">
            <feather v-if="b.ot == 122" type="youtube" :size="14"></feather>
            <div class="mg-l-5 lh-1">
              <span>{{ t.task }}</span>
            </div>
          </div>
          <!-- <span class="badge">15</span> -->
        </a>
      </nav>
      <nav class="nav" v-else-if="b.forms.length">
        <!-- <a @click="navopen(b)" role="button" :class="{'active': b.id==$route.params.bid && $route.params.iid==0 }">
            <span class="text-uppercase tx-12">Бүх {{b.nm}}</span>
        </a> -->
        <a
          @click="subNavOpen(b, f)"
          role="button"
          v-for="(f, i) in b.forms"
          :key="i"
          :class="{ active: f.id == $route.params.iid }"
        >
          <div>
            <div>{{ f.nm }}</div>
            <div class="progress ht-15" v-if="f.flag == 800">
              <div
                role="progressbar"
                :class="`progress-bar bg-${calcaulateProgressBg(f)}`"
                :style="{ width: calcaulateProgress(f) + '%' }"
              >
                <span class="tx-9"
                  >{{ calcaulateProgress(f).toFixed(2) }}%</span
                >
              </div>
            </div>
            <div class="text-muted tx-12">
              {{ f.fillingCount }} / {{ f.qCount }} / ({{ f.attemptCount }}
              {{ f.flag }} {{ f.resultCount }})
            </div>
          </div>
        </a>
      </nav>
      <nav class="nav" v-else-if="b.attaches.length">
        <!-- <a @click="navopen(b)" role="button" :class="{'active': b.id==$route.params.bid && $route.params.iid==0 }">
            <span class="text-uppercase tx-12">Бүх {{b.nm}}</span>
        </a> -->
        <a
          @click="subNavOpen(b, a)"
          role="button"
          v-for="(a, i) in b.attaches"
          :key="i"
          :class="{ active: a.id == $route.params.iid }"
        >
          <div class="d-flex align-items-center">
            <div class="mg-r-5 tx-12">{{ i + 1 }}.</div>
            <i
              v-if="!a.isCompleted"
              :class="
                `mg-r-10 far ${getFileIcon(a)} tx-16 tx-${getTextColor(a)}`
              "
            ></i>
            <div v-else class="mg-r-8">
              <div class="avatar wd-15-f ht-15-f">
                <span class="avatar-initial rounded-circle op-5 bg-success">
                  <feather type="check" :size="16"></feather>
                </span>
              </div>
            </div>
            <div class="lh-3">
              <div>{{ a.t != "" ? a.t : a.n }}</div>
              <span class="tx-11 text-muted">{{ getSize(a.s) }} {{ a.e }}</span>
            </div>
          </div>
        </a>
      </nav>
    </li>
  </ul>
</template>

<script>
import { getSize, getFileIcon } from "@/libs/tools";
export default {
  props: {
    boxes: {
      type: Array,
      default: () => []
    }
  },
  mounted() {},
  methods: {
    prevOrNextContent(e) {
      if (e.mode == 0) {
        this.navopen(this.boxes[0]);
      } else {
        let _b = this.boxes.filter(x => x.id == e.params.bid);

        if (_b.length) {
          let boxOption = "";

          if (e.params.iid > 0) {
            if (_b[0].attaches.length) {
              boxOption = "attaches";
            } else if (_b[0].forms.length) {
              boxOption = "forms";
            } else if (_b[0].tasks.length) {
              boxOption = "tasks";
            }

            let ind = _b[0][boxOption]
              .map(a => {
                return a.id;
              })
              .indexOf(e.params.iid);
            let indBox = this.boxes
              .map(b => {
                return b.id;
              })
              .indexOf(e.params.bid);
            if (ind == 0 && e.mode == -1) {
              this.navopen(_b[0]);
            } else if (ind == _b[0][boxOption].length - 1 && e.mode == 1) {
              //console.log('end bnuu');
              if (indBox + 1 == this.boxes.length)
                this.$emit("on-show-next-lesson");
              else this.navopen(this.boxes[indBox + e.mode]);
            } else {
              let _item = _b[0][boxOption][ind + e.mode];
              this.subNavOpen(_b[0], _item);
            }
          } else if (e.params.iid == 0 && e.params.bid > 0 && e.mode == -1) {
            let indBox = this.boxes
              .map(b => {
                return b.id;
              })
              .indexOf(e.params.bid);
            if (indBox > 0) {
              if (this.boxes[indBox - 1].attaches.length) {
                boxOption = "attaches";
              } else if (this.boxes[indBox - 1].forms.length) {
                boxOption = "forms";
              } else if (this.boxes[indBox - 1].tasks.length) {
                boxOption = "tasks";
              }

              if (this.boxes[indBox + e.mode][boxOption].length) {
                let _item = {};
                _item = this.boxes[indBox + e.mode][boxOption][
                  this.boxes[indBox + e.mode][boxOption].length - 1
                ];
                this.subNavOpen(this.boxes[indBox + e.mode], _item);
              } else {
                this.navopen(this.boxes[indBox + e.mode]);
              }
            } else {
              this.navhome();
            }
          } else if (e.params.iid == 0 && e.params.bid > 0 && e.mode == 1) {
            if (_b[0].attaches.length) {
              boxOption = "attaches";
            } else if (_b[0].forms.length) {
              boxOption = "forms";
            } else if (_b[0].tasks.length) {
              boxOption = "tasks";
            }

            if (_b[0][boxOption].length) {
              this.subNavOpen(_b[0], _b[0][boxOption][0]);
            }
          }
        }
      }
      //console.log('prevOrNextContent=> ', e);
    },
    navhome() {
      this.$router.push({
        name: "lmsLessonView",
        params: {
          id: this.$route.params.id,
          cid: this.$route.params.cid,
          bid: 0,
          iid: 0,
          bot: 0
        }
      });
    },
    navopen(box) {
      this.$router.push({
        name: "lmsLessonView",
        params: {
          id: this.$route.params.id,
          cid: this.$route.params.cid,
          bid: box.id,
          iid: 0,
          bot: box.ot
        }
      });
    },
    subNavOpen(box, t) {
      this.$router.push({
        name: "lmsLessonView",
        params: {
          id: this.$route.params.id,
          cid: this.$route.params.cid,
          bid: box.id,
          iid: t.id,
          bot: box.ot
        }
      });
      //&& this.lesson==undefined
      // if(box.ot==114){
      //   console.log('hicheel  rvv yavdaa');
      //   this.$router.push({name: 'lmsLessonView',
      //     params: {
      //       id: t.id,
      //       cid: this.$route.params.id,
      //       bid: 0,
      //       iid: 0
      //     }
      //   })
      // } else this.$emit("sub-nav-change", {boxId: box.id, itemId: t.id  } );
    },
    getSize(size) {
      return getSize(size);
    },
    getFileIcon(a) {
      return "fa-file-" + getFileIcon(a.e);
    },
    getTextColor(a) {
      //console.log(ex);
      let rv = a;
      // switch(ex){
      //   case 'ppt':
      //   case 'pptx': rv='orange'; break;
      //   case 'png':
      //   case 'jpg':
      //   case 'jpeg':
      //   case 'bmp':
      //     rv='indigo'; break;
      //   case 'xls':
      //   case 'xlsx':
      //     rv='success'; break;
      //   case 'doc':
      //   case 'docx':
      //     rv='primary'; break;
      //   case 'mp4':
      //   case '3gp':
      //     rv='pink'; break;
      //   default: break;
      // }
      return rv;
    },
    calcaulateProgress(f) {
      let rv = 0;
      rv = (f.fillingCount * 100) / f.qCount;
      return rv;
    },
    calcaulateProgressBg(f) {
      let rv = "secondary";
      let perc = (f.fillingCount * 100) / f.qCount;

      if (perc <= 9) {
        rv = "warning";
      } else if (perc <= 19) {
        rv = "gray-200";
      } else if (perc <= 29) {
        rv = "gray-300";
      } else if (perc <= 39) {
        rv = "gray-400";
      } else if (perc <= 49) {
        rv = "gray-500";
      } else if (perc <= 59) {
        rv = "gray-600";
      } else if (perc <= 69) {
        rv = "gray-700";
      } else if (perc <= 79) {
        rv = "gray-800";
      } else if (perc <= 89) {
        rv = "gray-900";
      } else if (perc <= 99) {
        rv = "gray-900";
      } else if (perc == 100) {
        rv = "success";
      }
      //console.log(perc, rv);
      return rv;
    }
  }
};
</script>

<style></style>
